import React, { memo } from 'react';
import { ChevronRight } from 'lucide-react';
export function WeddingsSection() {
  return <section className="relative py-32 px-8 overflow-hidden" data-id="element-465">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url(https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/10/Weddings-Web-hero.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }} data-id="element-466" />
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/50 z-0" data-id="element-467" />
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-468">
        {/* Pink Accent Line */}
        <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-469" />
        <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-470">
          Celebrations
        </div>
        <h2 className="font-heading text-5xl lg:text-6xl text-white mb-6 leading-tight" data-id="element-471">
          Weddings & Events
        </h2>
        <p className="text-xl text-white/90 mb-12 leading-relaxed max-w-3xl mx-auto" data-id="element-472">
          Create unforgettable memories at our picturesque vineyard. Our
          stunning venue offers breathtaking views and exceptional service for
          your special day.
        </p>
        <button className="inline-flex items-center gap-2 px-8 py-3 bg-white border border-white hover:bg-brand-pink hover:border-brand-pink transition-all duration-200 text-neutral-900 hover:text-white font-medium" data-id="element-473">
          Learn More
          <ChevronRight size={16} data-id="element-474" />
        </button>
        <p className="text-sm text-white/80 mt-6 italic" data-id="element-475">
          "Where love and celebration meet amongst the vines"
        </p>
      </div>
    </section>;
}